export default __webpack_public_path__ + "static/media/0x3068382885602fc0089aec774944b5ad6123ae60.d5ed6236.webp";